var map = {
	"./staff_01.png": 20897,
	"./staff_02.png": 60565,
	"./staff_03.png": 79705,
	"./staff_04.png": 9879,
	"./staff_05.png": 28221,
	"./staff_06.png": 86568
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39731;